<template>
  <div class="home_page h-full">
    <theHeader class="header-shadow" />
    <router-view class="men" />
  </div>
</template>

<script>
import theHeader from '@/component/helper/headerDevis'

export default {
  name: 'Home',
  components: {
    theHeader
  }
}
</script>
<style lang="scss" scoped>
@import "../assets/styles/sass/variables";
.home_page {
  width: 1440px;
  margin-left: auto;
  margin-right: auto;
  background-color: #F5F5F5;
  height: 100%;
}
@media screen and (max-width: 1440px) {
  .home_page {
    background-color: #F5F5F5;
    width: 100%;
    height: 100%;
  }
  .home_page::-webkit-scrollbar {
    display: none;
  }
}
</style>
